import m from "../../geodata/es2015/antiguaBarbudaHigh";
window.am4geodata_antiguaBarbudaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/antiguaBarbudaHigh.js
// module id = null
// module chunks = 